<template>
  <div mClass="main"  v-title data-title="北京天蔚中医药发展促进中心-信息公开">
    <mClass :nav="nav" ></mClass>
  </div>
</template>
<script>
import mClass from "@/components/mClass.vue";
import Bus from "@/utils/bus.js"
export default {
  data() {
    return {
      nav: [
        { title: "政策法规", url: "mzcfg" },
        { title: "管理制度", url: "mglzd" },
        { title: "年审结果", url: "mndbg" },
        // { title: "审计报告", url: "msjbg" },
        { title: "信息公告", url: "mxxgg" }
      ],
    };
  },
  mounted() {
    this.$nextTick(function() {
      Bus.$emit("getpCurrent", "mnewsInfo");
    });
  },
  methods: {
  },
  components: {
    mClass
  }
};
</script>

<style lang="less" scoped>
.main{
   width: 100%;
}
</style>